import { formatDateMethod2, formatDateMethod3 } from "../../utils/formatarData";
import {
  traqueostomiaProcedimentoOptions,
  ventilacaoNaoInvasivaDuracaoOptions,
} from "./dadosIniciais";

function getValueByKey(campo, key) {
  const option = campo.find((item) => item.key === key);
  return option ? option.value : null;
}

function opcaoSimNao(resposta) {
  if (resposta === "Sim") {
    return "50";
  }
  return "51";
}

function formatarDataTraqueostomia(data) {
  try {
    return formatDateMethod2(data);
  } catch {
    return formatDateMethod3(data);
  }
}

function multidisciplinarTipoOpcoes(resposta) {
  switch (resposta) {
    case "Fonoaudiologia":
      return "64";
    case "Fisioterapia":
      return "65";
    case "Psicologia":
      return "66";
    case "Nutrição":
      return "67";
    case "Enfermagem":
      return "68";
    case "Terapia Ocupacional":
      return "69";
    case "Cirurgião Dentista":
      return "70";
    case "Assistente Social":
      return "71";
    case "Pneumologista":
      return "72";
    default:
      break;
  }
}

function preencherRespostasBipap(
  dados,
  dataInicio,
  frequenciaUso,
  setDadadosIniciais
) {
  if (dataInicio || frequenciaUso) {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      ventilacaoNaoInvasivaBIPAP: "50",
    }));

    if (dataInicio) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        bipapDataInicio: dataInicio,
      }));
    }

    if (frequenciaUso) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        bipapDuracao: getValueByKey(
          ventilacaoNaoInvasivaDuracaoOptions,
          frequenciaUso
        ),
      }));
    }
  } else {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      ventilacaoNaoInvasivaBIPAP: opcaoSimNao(
        dados["Ventilação não invasiva (BIPAP):*"]
      ),
    }));
  }
}

function preencherRespostasTraqueostomia(
  opcaoSelecionada,
  dataProcedimento,
  procedimento,
  setDadadosIniciais
) {
  if (dataProcedimento || procedimento) {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      traquestomia: "50",
    }));

    if (dataProcedimento) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        traqueostomiaDataInicio: formatarDataTraqueostomia(dataProcedimento),
      }));
    }

    if (procedimento) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        traqueostomiaProcedimento: getValueByKey(
          traqueostomiaProcedimentoOptions,
          procedimento
        ),
      }));
    }
  } else {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      traquestomia: opcaoSimNao(opcaoSelecionada),
    }));
  }
}

function preencherRespostasGastrostomia(
  dados,
  dataProcedimento,
  setDadadosIniciais
) {
  if (dataProcedimento) {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      gastrostomia: "50",
    }));

    if (dataProcedimento) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        gastrostomiaDataInicio: dataProcedimento,
      }));
    }
  } else {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      gastrostomia: opcaoSimNao(dados["Gastrostomia*"]),
    }));
  }
}

function preencherRespostasComPerguntasDoRegistro(dados, setDadadosIniciais) {
  if (dados["Ventilação não invasiva (BIPAP):*"]) {
    let dataInicio =
      dados["Ventilação não invasiva (BIPAP):*"][
        "Se sim, data do início do uso*"
      ];
    const frequenciaUso =
      dados["Ventilação não invasiva (BIPAP):*"]["Se sim, frequência*"];

    dataInicio = formatDateMethod3(dataInicio);
    preencherRespostasBipap(
      dados,
      dataInicio,
      frequenciaUso,
      setDadadosIniciais
    );
  }

  if (dados["Traqueostomia*"]) {
    const dataProcedimento =
      dados["Traqueostomia*"]["Se sim, data do procedimento*"];
    const procedimento = dados["Traqueostomia*"]["Ela foi realizada*"];
    const opcaoSelecionada = dados["Traqueostomia*"];

    preencherRespostasTraqueostomia(
      opcaoSelecionada,
      dataProcedimento,
      procedimento,
      setDadadosIniciais
    );
  }

  if (dados["Gastrostomia*"]) {
    let dataProcedimento =
      dados["Gastrostomia*"]["Se sim, data do procedimento*"];
    dataProcedimento = formatDateMethod3(dataProcedimento);

    preencherRespostasGastrostomia(dados, dataProcedimento, setDadadosIniciais);
  }
}

function preencherRespostasComPerguntasDoAutorrelato(
  dados,
  setDadadosIniciais
) {
  if (dados["Ventilação não invasiva (BIPAP):"]) {
    let dataInicio =
      dados["Ventilação não invasiva (BIPAP):"][
        "Se sim, data do início do uso"
      ];
    const frequenciaUso =
      dados["Ventilação não invasiva (BIPAP):"]["Se sim, frequência"];

    dataInicio = formatDateMethod2(dataInicio);
    preencherRespostasBipap(
      dados,
      dataInicio,
      frequenciaUso,
      setDadadosIniciais
    );
  }

  if (dados["Traqueostomia"]) {
    const dataProcedimento =
      dados["Traqueostomia"]["Se sim, data do procedimento"];
    const procedimento = dados["Traqueostomia"]["Ela foi realizada"];
    const opcaoSelecionada = dados["Traqueostomia"];
    preencherRespostasTraqueostomia(
      opcaoSelecionada,
      dataProcedimento,
      procedimento,
      setDadadosIniciais
    );
  }

  if (dados["Gastrostomia"]) {
    let dataProcedimento =
      dados["Gastrostomia"]["Se sim, data do procedimento"];
    dataProcedimento = formatDateMethod2(dataProcedimento);
    preencherRespostasGastrostomia(dados, dataProcedimento, setDadadosIniciais);
  }

  if (dados["Alimentação por sonda nasogástrica"]) {
    const opcaoSelecionada = dados["Alimentação por sonda nasogástrica"];
    const dataProcedimento =
      dados["Alimentação por sonda nasogástrica"][
        "Se sim, data do procedimento"
      ];

    if (dataProcedimento) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        sondaNasogastrica: "50",
      }));

      if (dataProcedimento) {
        setDadadosIniciais((prevState) => ({
          ...prevState,
          sondaNasogastricaDataInicio: formatDateMethod2(dataProcedimento),
        }));
      }
    } else {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        sondaNasogastrica: opcaoSimNao(opcaoSelecionada),
      }));
    }
  }

  if (dados["Cough assist/máquina da tosse"]) {
    setDadadosIniciais((prevState) => ({
      ...prevState,
      coughAssist: opcaoSimNao(dados["Cough assist/máquina da tosse"]),
    }));
  }

  if (dados["Multidisciplinaridade oferecida"]) {
    if (Array.isArray(dados["Multidisciplinaridade oferecida"])) {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        multidisciplinar: "50",
      }));
      let multidisciplinarTipo = dados["Multidisciplinaridade oferecida"];
      let multidisciplinar = Array.isArray(multidisciplinarTipo)
        ? multidisciplinarTipo
        : [multidisciplinarTipo];
      let multidisciplinarTipoList = multidisciplinar.map(function (item) {
        return multidisciplinarTipoOpcoes(item);
      });

      setDadadosIniciais((prevState) => ({
        ...prevState,
        multidisciplinarTipo: multidisciplinarTipoList,
      }));
    } else {
      setDadadosIniciais((prevState) => ({
        ...prevState,
        multidisciplinar: opcaoSimNao(dados["Multidisciplinaridade oferecida"]),
      }));
    }
  }
}

export default function Insert(dadosRegistro, setDadadosIniciais) {
  if (dadosRegistro) {
    let dados = dadosRegistro.registro;

    if (dadosRegistro.paciente["Perfil"] === "Paciente/Autorrelato") {
      preencherRespostasComPerguntasDoAutorrelato(dados, setDadadosIniciais);
    } else if (dadosRegistro.paciente["Perfil"] === "Paciente/Registro") {
      preencherRespostasComPerguntasDoRegistro(dados, setDadadosIniciais);
    }
  }
}
